// extracted by mini-css-extract-plugin
module.exports = {"column":"FooterColumn_column__Od_lP","title":"FooterColumn_title__glm03","list":"FooterColumn_list__S0JX_","link":"FooterColumn_link__V78bX"};